export default class CartCommentModal extends HTMLDivElement {

    constructor() {
        super();

        this.route = this.dataset.route;
        this.button = this.querySelector('.modal-footer button');
        this.textarea = this.querySelector('textarea');
    }

    connectedCallback() {
        this.button.addEventListener('click', (event) => {
            event.preventDefault();
            this.updateComment();
        });
    }

    updateComment() {
        const comment = this.textarea.value;

        fetch(this.route, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            },
            body: JSON.stringify({ comment }),
        })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    window.location.reload(); // Reload the page to reflect the updated comment
                } else {
                    console.error('Error updating comment:', data.message);
                }
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }
}
